import { createPinia } from "pinia";
const pina = createPinia();
export default pina;
